import * as React from "react";
import { InputProps } from "../../types/InputProps";

import TextField from "@material-ui/core/TextField";

class InputTextArea extends React.Component<InputProps> {

    public render() {
        return (
            <TextField
                disabled={this.props.disabled}
                multiline={true}
                type="text"
                style={{ width: "100%",
                    border: "1px solid #381A0A",
                    borderRadius: "6px",
                    padding: "15px",
                    boxSizing: "border-box", color: "#381A0A" }}
                label={this.props.label ? this.props.label : null}
                placeholder={this.props.placeholder ? this.props.placeholder : null}
                value={this.props.value ? this.props.value : ""}
                error={this.props.error ? this.props.error : false}
                helperText={this.props.legend ? this.props.legend : ""}
                onChange={(event) => this.props.onChange(event.target.value, event.target)}
                required={this.props.required}
            />
        );
    }

}

export default InputTextArea;


// WEBPACK FOOTER //
// ./src/components/InputTextArea/InputTextArea.tsx